<template>
  <div class="flex flex-between flex-vertical-start mt-25">
    <!--New Item Source-->
    <template v-if="isNewLead">
      <p class="inbox_item--source">Source: {{ item.createdBy.display_name }}</p>
      <p class="inbox_item--date">{{ date }}</p>
    </template>

    <!--New Comm Source-->
    <template v-else-if="isInboundComm">
      <p class="inbox_item--source flex flex-vertical-center">
        <icon-default
          :icon="iconType"
          size="is-small"
          :color="iconColor"
          class="mr-25"
        ></icon-default>
        <span>
          {{ commText }}
          <span v-if="item.in_progress" class="call_in_progress">Call In Progress</span>
        </span>
      </p>
      <p class="inbox_item--date">{{ date }}</p>
    </template>
  </div>
</template>

<script>
import {ENUMS} from "../../../services/enums";
import {MODELS} from "../../../services/models";
import dates from "../../../services/dates";

export default {
  name: "InboxItemSource",
  props: {
    item: {
      type: Object,
      required: true,
    },
    isNewLead: {
      type: Boolean,
      default: false,
    },
    isInboundComm: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isCall() {
      if(!this.isInboundComm) return false;

      return this.item.type === ENUMS.CommunicationTypeEnum.Call.value;
    },
    isText() {
      if(!this.isInboundComm) return false;

      return this.item.type === ENUMS.CommunicationTypeEnum.Text.value;
    },
    isEmail() {
      if(!this.isInboundComm) return false;

      return this.item.type === ENUMS.CommunicationTypeEnum.Email.value;
    },
    iconColor() {
      if (this.isCall) return "is-call";
      if (this.isText) return "is-text";
      if (this.isEmail) return "is-email";
    },
    iconType() {
      if (this.isCall) return "call";
      if (this.isText) return "text";
      if (this.isEmail) return "email";
    },
    commText() {
      if (this.isCall) {
        return "To " + this.item.integration_label;
      }

      if (this.isText) {
        return this.$utils.truncateString(this.item.text_message.replace(/<[^>]*>?/gm, ''), 20);
      }

      if (this.isEmail) {
        return this.$utils.truncateString(this.item.email_subject, 20);
      }
    },
    date() {
      let date = null;
      if (this.isNewLead) date = this.item.created_at;
      if (this.isInboundComm) date = this.item.scheduled_at;

      return dates.formatAsDateTime(date);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.inbox_item {

  &--source {
    color: $text-muted;
    font-size: 0.75rem;
  }

  &--date {
    flex-shrink: 0;
    margin-left: 4px;
    color: $text-light;
    font-size: 0.75rem;
  }
}

.call_in_progress {
  display: block;
  margin-top: 2px;
  color: $primary;
}
</style>
